import React from 'react';
import { getMarketProducts } from 'ducks/products';
import { Product } from '@inter-ikea-storageone/range';
import { FilterType } from 'rangeConfig/@types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import SizeFilter from 'ui/SizeFilter/SizeFilter';
import { getFilterOptions, getFilterParams, getUnit } from './utils';

type Props = {
  products: Product[];
  filterState: any;
  type: FilterType;
  onFilter: (productIdList: string[], filterState: any) => void;
};

const WidthFilter = ({ products, filterState, onFilter, type }: Props) => {
  const { formatMessage } = useIntl();
  const availableWidths = getFilterOptions('width')(products);
  const unit = getUnit(products);
  const allProducts = useSelector(getMarketProducts);

  const onWidthFilter = (size: number) => {
    const { productIds, newFilterState } = getFilterParams(
      type,
      size,
      'width',
      products,
      allProducts,
      filterState
    );
    onFilter(productIds, newFilterState);
  };

  if (!products.length) {
    return null;
  }

  const label = `${formatMessage({ id: 'storageone.width' })} (${unit}):`;

  return (
    <SizeFilter
      id="width-id"
      data-testid="width-id"
      label={label}
      name="width-filter"
      sizes={availableWidths}
      onFilter={onWidthFilter}
      filterState={filterState}
    />
  );
};

export default WidthFilter;
